/**
 * Draft lines → create payload（camel；serialize 再 keysToSnake）。
 * 有值才帶 unitId。
 *
 * @param {object} options
 * @param {string} options.transferDate
 * @param {string} options.toWarehouseId
 * @param {string} [options.issueReason]
 * @param {string} [options.remark]
 * @param {array} options.draftLines
 */
export function mapTransferDraftToCreatePayload({
  transferDate,
  toWarehouseId,
  issueReason = null,
  remark = null,
  draftLines = [],
}) {
  return {
    transferDate: transferDate || null,
    toWarehouseId: toWarehouseId || null,
    issueReason: issueReason || null,
    remark: remark || null,
    lines: (draftLines ?? []).map((line) => {
      const qty = Number(line?.qty) || 0;
      const mapped = {
        invStockId: line?.invStockId ?? null,
        qty,
        toLocationId: line?.toLocationId || null,
        stockNoPolicy: line?.stockNoPolicy || 'TRANSFERRED_KEEP_OLD',
        remark: line?.remark ?? null,
      };
      const unitId = String(line?.unitId ?? '').trim();
      if (unitId) {
        mapped.unitId = unitId;
      }
      return mapped;
    }),
  };
}
